import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";
import InfoTooltip from "../../givBee/infoTooltip/InfoTooltip";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import SaveButton from "../../givBee/buttons/SaveButton";
import Button from "@material-ui/core/Button";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CreateButton from "../../givBee/buttons/CreateButton";
// import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// import FetchServerData from "../../provider/FetchServerData";
import { MESSAGE_TYPES } from "../../../provider/Enums";
import MessageQuestion from "./MessageQuestion";
import FetchServerData from "../../../provider/FetchServerData";

class CustomerMessageTemplate extends Component {
  header = store.getState().header.header;
  smsMessageTypeList = store.getState().staticData.smsMessageTypeList;
  interactiveQuestionTypeList =
    store.getState().staticData.interactiveQuestionTypeList;
  businessTypeList = store.getState().staticData.businessTypeList;
  smsVariablesList = store.getState().staticData.smsVariablesList;
  smsFundraisingOptionList =
    store.getState().staticData.smsFundraisingOptionList;
  itemReferenceList = [];
  valueIndexMap = new Map();
  constructor(props) {
    super(props);
    const modifiedData = [...(this.smsFundraisingOptionList || [])];
    modifiedData.map((item) => {
      if (Utils.equalsIgnoreCase(item.name, "Without Introduction")) {
        item.isChecked = true;
        return item;
      }
    });

    this.state = {
      messageTypeList: [],
      questionItems: [],
      interactiveQuestionTypeList: [],
      smsFundraisingOptionList: modifiedData,
      donnerExperince: Utils.getArrayElement(this.smsFundraisingOptionList, 0),
      messageType: this.smsMessageTypeList[0],
      messageName: "",
      keyword: "",
      message: "",
      introMessage: "",
      closingTextMessage: "",
      amountQuestion: "",
      amountOption1: "50",
      amountOption2: "25",
      amountOption3: "10",
      amountOption4: null,
      donationAmount: "",
      donationAmountList: ["50", "25", "10"],
      isIntroMessage: false,
      donationAmountError: false,
      open: props.open,
      action: props.action,
      onChange: props.onChange,
      render: false,
    };
  }

  showMessageTemplate(rowData, action) {
    if (null !== rowData?.id && rowData?.id > 0) {
      this.getMsgTemplateDetails(rowData?.id);
    } else {
      this.setState({
        open: true,
        messageTypeList: [],
        questionItems: [],
        interactiveQuestionTypeList: [],
        smsFundraisingOptionList: [],
        messageType: this.smsMessageTypeList[0],
        messageName: "",
        keyword: "",
        message: "",
        introMessage: "",
        closingTextMessage: "",
        amountQuestion: "",
        amountOption1: "50",
        amountOption2: "25",
        amountOption3: "10",
        amountOption4: null,
        donationAmount: "",
        donnerExperince: "",
        donationAmountList: ["50", "25", "10"],
        isIntroMessage: false,
        donationAmountError: false,
        action: action,
      });
    }
  }

  getMsgTemplateDetails(smsTemplateId) {
    const postObject = {
      header: this.header,
      messageTemplate: {
        id: smsTemplateId,
      },
    };
    FetchServerData.callPostService("/custMsgTemplatems/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let msgTemplateDetails = output.data.messageTemplate;
          let messageTemplateFundRaisingDetails =
            msgTemplateDetails?.messageTemplateFundRaising;
          let questionType = {};
          for (
            let i = 0;
            i < msgTemplateDetails.messageTemplateQuestions.length;
            i++
          ) {
            let ref = React.createRef();
            this.itemReferenceList.push(ref);
            msgTemplateDetails.messageTemplateQuestions[i].operation = "Update";
            if (
              msgTemplateDetails.messageTemplateQuestions[i]?.questionType
                ?.type === "Pledge"
            ) {
              questionType.type =
                msgTemplateDetails.messageTemplateQuestions[
                  i
                ]?.questionType?.type;
              this.valueIndexMap.set(i, questionType.type);
            }
          }
          if (messageTemplateFundRaisingDetails !== null) {
            let donationAmountList = [];
            if (
              messageTemplateFundRaisingDetails?.amountOption1 !== null &&
              messageTemplateFundRaisingDetails?.amountOption1 !== undefined
            ) {
              donationAmountList.push(
                messageTemplateFundRaisingDetails?.amountOption1
              );
            }
            if (
              messageTemplateFundRaisingDetails?.amountOption2 !== null &&
              messageTemplateFundRaisingDetails?.amountOption2 !== undefined
            ) {
              donationAmountList.push(
                messageTemplateFundRaisingDetails?.amountOption2
              );
            }
            if (
              messageTemplateFundRaisingDetails?.amountOption3 !== null &&
              messageTemplateFundRaisingDetails?.amountOption2 !== undefined
            ) {
              donationAmountList.push(
                messageTemplateFundRaisingDetails?.amountOption3
              );
            }
            if (
              messageTemplateFundRaisingDetails?.amountOption4 !== null &&
              messageTemplateFundRaisingDetails?.amountOption2 !== undefined
            ) {
              donationAmountList.push(
                messageTemplateFundRaisingDetails?.amountOption4
              );
            }
            const modifiedData = [...this.smsFundraisingOptionList];
            modifiedData?.map((item) => {
              item.isChecked =
                item.id ===
                +messageTemplateFundRaisingDetails?.donnerExperince?.id;
              return item;
            });
            let isIntroMessage = false;
            if (
              Utils.equalsIgnoreCase(
                messageTemplateFundRaisingDetails?.donnerExperince?.name,
                "With Introduction"
              )
            ) {
              isIntroMessage = true;
            }
          }
          this.setState({
            render: true,
            open: true,
            action: "edit",
            id: msgTemplateDetails.id,
            messageName: msgTemplateDetails.messageName,
            keyword: msgTemplateDetails.keyword,
            message: msgTemplateDetails.textMessage,
            messageType: msgTemplateDetails.messageType,
            closingTextMessage: msgTemplateDetails.closingMessage,
            questionItems: msgTemplateDetails.messageTemplateQuestions,
            introMessage: messageTemplateFundRaisingDetails?.introMessage,
            fundraisingGoal: msgTemplateDetails?.goalAmount,
            amountQuestion: messageTemplateFundRaisingDetails?.amountQuestion,
            amountOption1: messageTemplateFundRaisingDetails?.amountOption1,
            amountOption2: messageTemplateFundRaisingDetails?.amountOption2,
            amountOption3: messageTemplateFundRaisingDetails?.amountOption3,
            amountOption4: messageTemplateFundRaisingDetails?.amountOption4,
            // donationAmountList: donationAmountList,
            donnerExperince: messageTemplateFundRaisingDetails?.donnerExperince,
            smsMessageFundRaisingId: messageTemplateFundRaisingDetails?.id,
            // smsFundraisingOptionList: modifiedData,
            // isIntroMessage: isIntroMessage,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleMessageNameChange(e) {
    this.setState({ messageName: e.target.value });
  }
  handleKeywordChange(e) {
    this.setState({ keyword: e.target.value });
  }
  handleMessageChange(e) {
    this.setState({ message: e.target.value });
  }

  handleBusinessTypeChange(selectedValue) {
    this.setState({ businessType: selectedValue });
  }
  // handleMessageTypeChange(selectedValue) {
  //   if (
  //     Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.interactive)
  //   ) {
  //     this.addQuestionItem();
  //     this.setState({ messageType: selectedValue });
  //   } else {
  //     this.setState({ messageType: selectedValue });
  //   }
  // }

  handleMessageTypeChange(selectedValue) {
    if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.interactive)
    ) {
      this.addQuestionItem();
      this.setState({
        messageType: selectedValue,
        textMessage: this.state.textMessage,
        messageName: this.state.messageName,
        keyword: this.state.keyword,
      });
    } else if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.fundraising)
    ) {
      if (this.state.action === "create") {
        const modifiedData = [...this.smsFundraisingOptionList];
        let isIntroMessage = true;
        modifiedData.map((item) => {
          if (Utils.equalsIgnoreCase(item.name, "Without Introduction")) {
            item.isChecked = true;
            isIntroMessage = false;
            return item;
          } else {
            item.isChecked = false;
            return item;
          }
        });
        this.setState({
          messageType: selectedValue,
          questionItems: [],
          textMessage: this.state.textMessage,
          closingMessage: "",
          shortlinkUrl: "",
          shortUrl: "",
          messageName: this.state.messageName,
          keyword: this.state.keyword,
          neonRecordActivity: null,
          donnerExperince: this.smsFundraisingOptionList[0],
          smsFundraisingOptionList: modifiedData,
          isIntroMessage: isIntroMessage,
          amountQuestion: "How much would you like to give?",
        });
      } else {
        this.setState({
          messageType: selectedValue,
          questionItems: [],
          textMessage: this.state.textMessage,
          closingMessage: "",
          messageName: this.state.messageName,
          keyword: this.state.keyword,
        });
      }
    } else if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.optOut)
    ) {
      // this.getMessageTemplateList(selectedValue);
      this.setState({
        messageType: selectedValue,
        questionItems: [],
        textMessage: this.state.textMessage,
        closingMessage: "",
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        messageTemplate: this.state.messageTemplate,
      });
    } else {
      // this.getMessageTemplateList(selectedValue);
      this.setState({
        messageType: selectedValue,
        questionItems: [],
        closingMessage: "",
      });
    }
  }

  addQuestionItem() {
    let items = this.state.questionItems;
    let item = {
      operation: "ADD",
      question: "",
      questionType: this.interactiveQuestionTypeList[0],
    };
    items.push(item);
    this.itemReferenceList.push(React.createRef());
    this.setState({ questionItems: items });
  }

  smsQuestionTypeChange(selectedValue, index) {
    this.valueIndexMap.set(index, selectedValue.type);
    this.setState({ questionType: selectedValue });
  }

  QuestionItemDeleted(item, index) {
    if (this.valueIndexMap.has(index)) {
      this.valueIndexMap.delete(index);
    }
    let items = [];
    let itemToTrash = -999;
    for (let i = 0; i < this.state.questionItems.length; i++) {
      let invItem = this.state.questionItems[i];
      if (Utils.equalsIgnoreCase(this.state.action, "create")) {
        if (item.isDelete === true && item.index === i) {
          itemToTrash = i;
          continue;
        } else {
          invItem =
            this.itemReferenceList[i] && this.itemReferenceList[i].current
              ? this.itemReferenceList[i].current.state
              : invItem;
          items.push(invItem);
        }
      } else {
        if (item.isDelete === true && item.index === i) {
          if (Utils.equalsIgnoreCase(item.operation, "Add")) {
            itemToTrash = i;
            continue;
          }
          invItem.operation = "Delete";
        } else {
          invItem =
            this.itemReferenceList[i] && this.itemReferenceList[i].current
              ? this.itemReferenceList[i].current.state
              : invItem;
        }
        items.push(invItem);
      }
    }

    for (let i = 0; i < this.state.questionItems.length; i++) {
      if (i === itemToTrash) {
      }
    }

    let randomKey = Math.random();
    this.setState({ refreshKey: randomKey, questionItems: items });
  }

  handleClosingTextMessageChange(e) {
    this.setState({
      closingTextMessage: e.target.value,
    });
  }

  handleClosingTextMessageInsert(selectedValue) {
    this.setState({
      closingTextMessage: `${this.state.closingTextMessage.substring(
        0,
        this.state.start
      )} ${selectedValue.value} ${this.state.closingTextMessage.substring(
        this.state.start
      )}`,
    });
  }

  handleSmsVariableOnDrag(e) {
    e.preventDefault();
    let smsVariable = e.target.innerHTML;
    this.setState((prevState) => ({
      closingTextMessage: `${prevState.closingTextMessage.substring(
        0,
        this.state.start
      )} ${smsVariable} ${prevState.closingTextMessage.substring(
        this.state.start
      )}`,
      start: `${prevState.closingTextMessage.substring(
        0,
        this.state.start
      )} ${smsVariable} ${prevState.closingTextMessage.substring(
        this.state.start
      )}`.length,
    }));
  }

  handleChange(e, selectedValue) {
    const value = e.target.value;
    const modifiedData = [...this.smsFundraisingOptionList];
    modifiedData.map((item) => {
      item.isChecked = item.id === +value;
      return item;
    });
    let isIntroMessage = false;
    let introMessage = "";
    if (selectedValue.name === "With Introduction") {
      isIntroMessage = true;
      introMessage = "STOP to optout";
    } else {
      isIntroMessage = false;
      introMessage = "";
    }

    this.setState({
      introMessage: introMessage,
      isIntroMessage: isIntroMessage,
      smsFundraisingOptionList: modifiedData,
      donnerExperince: selectedValue,
    });
  }

  handleDonationAmountChange(e) {
    let val = e.target.value;
    this.setState({
      donationAmount: val,
    });
  }

  handleFundraisingGoalChange(e) {
    this.setState({
      fundraisingGoal: e.target.value,
    });
  }
  addDonationAmount() {
    let items = this.state.donationAmountList;
    if (items.length <= 3) {
      items.push(this.state.donationAmount);
    }
    this.setState({
      donationAmountList: items,
      amountOption1: items[0],
      amountOption2: items[1],
      amountOption3: items[2],
      amountOption4: items[3],
      donationAmount: "",
      donationAmountError: false,
    });
  }

  deleteDonationAmount(id) {
    const currentIndex = this.state.donationAmountList.findIndex(
      (d, index) => index === id
    );
    let currentList = [...this.state.donationAmountList];
    currentList.splice(currentIndex, 1);
    this.setState({
      donationAmountList: currentList,
      amountOption1: currentList[0] === undefined ? null : currentList[0],
      amountOption2: currentList[1],
      amountOption3: currentList[2],
      amountOption4: currentList[3],
    });
  }

  handleAmountQustionChange(e) {
    this.setState({
      amountQuestion: e.target.value,
    });
  }

  handleIntroMessageChange(e) {
    this.setState({
      introMessage: e.target.value,
    });
  }

  createMsgTemplateToBackend() {
    for (let i = 0; i < this.itemReferenceList.length; i++) {
      if (this.itemReferenceList[i].current) {
        this.state.questionItems[i].questionType =
          this.itemReferenceList[i].current.state.questionType;
        this.state.questionItems[i].discontinueReason =
          this.itemReferenceList[i].current.state.discontinueReason;
        this.state.questionItems[i].question =
          this.itemReferenceList[i].current.state.question;
        this.state.questionItems[i].step = i + 1;
      }
    }

    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      if (this.state.donationAmountList.length === 0) {
        this.setState({
          donationAmountError: true,
        });
        return;
      }

      let smsMessageFundRaising = {
        amountQuestion: this.state.amountQuestion,
        introMessage: this.state.introMessage,
        amountOption1: this.state.amountOption1,
        amountOption2: this.state.amountOption2,
        amountOption3: this.state.amountOption3,
        amountOption4: this.state.amountOption4,
        donnerExperince: this.state.donnerExperince,
      };
      this.setState({
        smsMessageFundRaising: smsMessageFundRaising,
        messageTemplate: null,
        textMessage: "",
      });
    }

    const postObject = {
      header: this.header,
      messageTemplate: {
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        textMessage: this.state.message,
        messageType: { id: this.state.messageType?.id },
        closingMessage: this.state.closingTextMessage,
        messageTemplateQuestions: this.state.questionItems,
        goalAmount: this.state.fundraisingGoal,
        messageTemplateFundRaising: this.state.smsMessageFundRaising,
      },
    };
    FetchServerData.callPostService(
      "/custMsgTemplatems/create",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.state.onChange(this.state);
        this.setState({
          open: false,
        });
      } else {
      }
    });
  }

  updateMsgTemplateToBackend() {
    for (let i = 0; i < this.itemReferenceList.length; i++) {
      if (this.itemReferenceList[i].current) {
        this.state.questionItems[i].questionType =
          this.itemReferenceList[i].current.state.questionType;
        this.state.questionItems[i].discontinueReason =
          this.itemReferenceList[i].current.state.discontinueReason;
        this.state.questionItems[i].question =
          this.itemReferenceList[i].current.state.question;
        this.state.questionItems[i].step = i + 1;
      }
    }

    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      if (this.state.donationAmountList.length === 0) {
        this.setState({
          donationAmountError: true,
        });
        return;
      }

      let smsMessageFundRaising = {
        id: this.state.smsMessageFundRaisingId,
        amountQuestion: this.state.amountQuestion,
        introMessage: this.state.introMessage,
        amountOption1: this.state.amountOption1,
        amountOption2: this.state.amountOption2,
        amountOption3: this.state.amountOption3,
        amountOption4: this.state.amountOption4,
        donnerExperince: { id: this.state.donnerExperince?.id },
      };
      this.setState({
        smsMessageFundRaising: smsMessageFundRaising,
        messageTemplate: null,
        textMessage: "",
      });
    }

    const postObject = {
      header: this.header,
      messageTemplate: {
        id: this.state.id,
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        textMessage: this.state.message,
        closingMessage: this.state.closingTextMessage,
        messageTemplateQuestions: this.state.questionItems,
        messageType: { id: this.state.messageType?.id },
        goalAmount: this.state.fundraisingGoal,
        messageTemplateFundRaising: this.state.smsMessageFundRaising,
      },
    };
    FetchServerData.callPostService(
      "/custMsgTemplatems/update",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.state.onChange(this.state);
        this.setState({
          open: false,
        });
      } else {
      }
    });
  }

  render() {
    if (this.state.action === "create") {
      return this.createMessageTemplate();
    } else if (this.state.action === "edit") {
      return this.editMessageTemplate();
    }
  }
  createMessageTemplate() {
    let questionitems = [];
    /* Create List of Expense Item */
    let itemLoc = 1;
    this.state.questionItems.forEach((element, index) => {
      if ("Delete" !== element.operation) {
        element.step = itemLoc++;
        let itemkey = index + "-" + this.state.refreshKey;
        questionitems.push(
          <MessageQuestion
            ref={this.itemReferenceList[index]}
            key={itemkey}
            data={element}
            srno={index}
            action="edit"
            iteamIndex={index}
            questionItems={this.state.questionItems}
            onAdd={this.addQuestionItem.bind(this)}
            onDelete={this.QuestionItemDeleted.bind(this)}
            // onChange={this.expenseItemChanged.bind(this)}
            onSuccess={this.smsQuestionTypeChange.bind(this)}
          />
        );
      }
    });
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xxl"
          className="TemplateDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Message Template</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent>
            <div
              className="row d-flex"
              style={{
                color: "#000",
                fontSize: "small",
              }}
            >
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.createMsgTemplateToBackend.bind(this)}
              >
                <div className="row" style={{ marginTop: "1em" }}>
                  <div className="col-md-12">
                    <div className="card" id="organizationFormCard">
                      <div className="card-body">
                        <div
                          className="row"
                          style={{
                            borderBottom: "1px solid rgb(228, 222, 222)",
                          }}
                        >
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-6 " id="assetFormLabel">
                                <label
                                  className="form-label "
                                  htmlFor="collapsible-firstname"
                                >
                                  Message Title*
                                </label>
                                <input
                                  title=""
                                  required
                                  type="text"
                                  autoComplete="off"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.messageName}
                                  onChange={this.handleMessageNameChange.bind(
                                    this
                                  )}
                                  validators={["required"]}
                                  errormessages={["This field is required"]}
                                />
                              </div>
                            </div>
                            <div className="row  mt-1">
                              <div className="col-md-6" id="assetFormLabel">
                                <label
                                  className="MuiAutocomplete-label form-label"
                                  htmlFor="collapsible-appUserRole"
                                >
                                  Message Type*
                                </label>
                                <Autocomplete
                                  id="size-small-outlined"
                                  size="small"
                                  fullWidth
                                  disableClearable
                                  autoComplete="off"
                                  options={this.smsMessageTypeList}
                                  value={this.state.messageType}
                                  getOptionLabel={(option) => option.type}
                                  defaultValue={this.state.messageType}
                                  onChange={(event, value) => {
                                    this.handleMessageTypeChange(value);
                                  }}
                                  inputprops={{
                                    style: { textTransform: "capitalize" },
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Please Select"
                                      variant="outlined"
                                      size="small"
                                      className="autoComplete"
                                      style={{ background: "#fff" }}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <div className="row mt-1 mb-4">
                              <div className="col-md-6 " id="assetFormLabel">
                                <label
                                  className="form-label "
                                  htmlFor="collapsible-lastname"
                                >
                                  Keyword
                                </label>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  id="multiStepsKeyword"
                                  name="multiStepsKeyword"
                                  className="form-control"
                                  value={this.state.keyword}
                                  onChange={this.handleKeywordChange.bind(this)}
                                  validators={["required"]}
                                  errormessages={["This field is required"]}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2 mb-4">
                          {!Utils.equalsIgnoreCase(
                            this.state.messageType?.type,
                            MESSAGE_TYPES.interactive
                          ) &&
                            !Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.fundraising
                            ) && (
                              <div
                                className="col-md-6 mt-1"
                                id="assetFormLabel"
                              >
                                <label
                                  className="form-label "
                                  htmlFor="collapsible-appUserRole"
                                >
                                  Message*
                                </label>
                                <textarea
                                  title=""
                                  required
                                  value={this.state.message}
                                  onChange={this.handleMessageChange.bind(this)}
                                  className="form-control"
                                  id="exampleFormControlTextarea1"
                                  rows="3"
                                />
                              </div>
                            )}
                        </div>
                        {Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.interactive
                        ) && (
                            <>
                              <div className="row" style={{ marginTop: "1em" }}>
                                <div className="col-md-12">
                                  {/* <div className="row mb-3"> */}
                                  {questionitems.length === 0 && (
                                    <div className="row">
                                      <div
                                        className="col-md-8"
                                        style={{
                                          background: "#ececec",
                                          color: "#000",
                                          fontWeight: "bold",
                                          border: "0.5px solid #ece6e6",
                                          padding: "0.5em",
                                        }}
                                      >
                                        {/* Message Type */}
                                      </div>
                                      <div
                                        className="col-md-4"
                                        style={{
                                          borderRight: "1px solid #eceaea",
                                          background: "#ececec",
                                          color: "#000",
                                          fontWeight: "bold",
                                          padding: "0.5em",
                                          textAlign: "right",
                                        }}
                                      >
                                        <Button
                                          type="button"
                                          // id="ptsHollowButton"
                                          className="btn btn-default "
                                          style={{
                                            textTransform: "capitalize",
                                            padding: "5px 10px",
                                            background: "#37517e",
                                            color: "#fff",
                                            fontWeight: "bold",
                                          }}
                                          startIcon={<AddIcon />}
                                          onClick={this.addQuestionItem.bind(
                                            this
                                          )}
                                        >
                                          Insert Message
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                                  <div className="row">
                                    <div className="col-md-12">
                                      {questionitems}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: "1em" }}>
                                <div className="col-md-12">
                                  <div className="row mb-3">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor="exampleFormControlTextarea1"
                                        className="form-label"
                                      >
                                        Closing/Thank You Message*
                                      </label>
                                      <textarea
                                        title=""
                                        required
                                        value={this.state.closingTextMessage}
                                        onChange={this.handleClosingTextMessageChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="3"
                                      />
                                    </div>
                                    <div className="col-md-3 mt-4">
                                      <ul style={{ listStyle: "none" }}>
                                        {this.smsVariablesList.map(
                                          (data, index) => {
                                            return (
                                              <>
                                                <li className="d-flex mt-1">
                                                  <Tooltip
                                                    title={data.value}
                                                    aria-label="add"
                                                    classes={{
                                                      popper: "custom-tooltip",
                                                    }}
                                                  >
                                                    <IconButton>
                                                      <CopyToClipboard
                                                        text={data.value}
                                                        onClick={this.onCopy}
                                                      >
                                                        <FileCopyIcon
                                                          style={{
                                                            color: "gray",
                                                            fontSize: "20px",
                                                          }}
                                                          onClick={this.handleClosingTextMessageInsert.bind(
                                                            this,
                                                            data
                                                          )}
                                                        />
                                                      </CopyToClipboard>
                                                    </IconButton>
                                                  </Tooltip>
                                                  &nbsp;
                                                  <div
                                                    className="mt-2"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onDragEnd={this.handleSmsVariableOnDrag.bind(
                                                      this
                                                    )}
                                                    key={index}
                                                    draggable
                                                  >
                                                    {data.value}
                                                  </div>
                                                </li>
                                              </>
                                            );
                                          }
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        {Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.fundraising
                        ) && (
                            <>
                              <div className="row" style={{ marginTop: "1em" }}>
                                <div className="col-md-12">
                                  <div className="row">
                                    <h6>
                                      <b>Choose a Donor Experience</b>
                                    </h6>
                                  </div>
                                  {this.smsFundraisingOptionList.map(
                                    (row, index) => {
                                      return (
                                        <>
                                          <div className="row p-1">
                                            <label
                                              className="col-md-3 col-form-label fw-bold"
                                              htmlFor="basic-default-supplierType"
                                              id="assetFormLabel"
                                            >
                                              <span className="me-2 custom-radio">
                                                <input
                                                  type="radio"
                                                  value={row.id}
                                                  onChange={(e) =>
                                                    this.handleChange(e, row)
                                                  }
                                                  checked={row.isChecked}
                                                />
                                              </span>
                                              <span className="me-4">
                                                {row.name}
                                              </span>
                                              {"  "}
                                              <span className="ms-4 fw-normal">
                                                {row.name === "With Introduction"
                                                  ? "(more descriptive)"
                                                  : "(fewer steps)"}
                                              </span>
                                            </label>
                                            <div className="col-md-9 mt-2">
                                              <span>{row.description}</span>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                  {this.state.isIntroMessage && (
                                    <div className="row p-1">
                                      <div className="col-md-3 mt-2"></div>
                                      <div className="col-md-6 mt-2">
                                        <span>
                                          Enter an Introduction Message that
                                          includes your organization's name and
                                          what this appeal is about. It must also
                                          elicit a "Yes" or "No" reply from
                                          recipient.
                                        </span>
                                        <textarea
                                          title=""
                                          required
                                          value={this.state.introMessage}
                                          onChange={this.handleIntroMessageChange.bind(
                                            this
                                          )}
                                          className="form-control"
                                          id="exampleFormControlTextarea1"
                                          rows="3"
                                        />
                                        <span
                                          className="ms-2"
                                          style={{
                                            fontSize: "12px",
                                            color: "black",
                                          }}
                                        >
                                          Whenever possible, please include
                                          opt-out language in your text message to
                                          show the carriers that you are following
                                          guidelines.
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: "1em" }}>
                                <div className="col-md-12">
                                  <div className="row mb-3">
                                    <div className="col-md-6">
                                      <label
                                        htmlFor="exampleFormControlTextarea1"
                                        className="form-label"
                                      >
                                        Your "How much?" Question*
                                      </label>
                                      <textarea
                                        title=""
                                        required
                                        value={this.state.amountQuestion}
                                        onChange={this.handleAmountQustionChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="3"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: "1em" }}>
                                <div className="col-md-12">
                                  <div className="row mb-3">
                                    <label
                                      htmlFor="exampleFormControlTextarea1"
                                      className="form-label"
                                    >
                                      Your Suggested Donation Amounts*
                                      <InfoTooltip
                                        data="Up to 4 allowed"
                                        style={{
                                          float: "right",
                                        }}
                                      />
                                    </label>
                                  </div>
                                  <div className="row mb-3 ">
                                    <div className="col-md-3 d-flex">
                                      <span className="input-group-addon">$</span>
                                      <input
                                        type="number"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control rounded-0"
                                        value={this.state.donationAmount}
                                        onChange={this.handleDonationAmountChange.bind(
                                          this
                                        )}
                                      />
                                      <span>
                                        <button
                                          type="button"
                                          onClick={this.addDonationAmount.bind(
                                            this
                                          )}
                                          className="btn addDonationBtn btn-primary"
                                        >
                                          Add
                                        </button>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row mt-4">
                                    <div className="col-md-4">
                                      <ul
                                        style={{
                                          listStyle: "none",
                                          display: "flex",
                                        }}
                                      >
                                        {this.state.donationAmountList?.map(
                                          (amountValue, index) => {
                                            return (
                                              <>
                                                {
                                                  <div className="donation d-flex">
                                                    <li>${amountValue}</li>
                                                    <span className="ms-4">
                                                      <i
                                                        className="fa fa-times"
                                                        aria-hidden="true"
                                                        onClick={this.deleteDonationAmount.bind(
                                                          this,
                                                          index
                                                        )}
                                                      ></i>
                                                    </span>
                                                  </div>
                                                }
                                              </>
                                            );
                                          }
                                        )}
                                      </ul>
                                      <span className="asterisk">
                                        {this.state.donationAmountError
                                          ? "No suggested donation amounts are set."
                                          : ""}
                                      </span>
                                    </div>
                                  </div>
                                  <hr></hr>
                                  <div className="row">
                                    <div
                                      className="col-md-4 mt-1"
                                      id="assetFormLabel"
                                    >
                                      <label
                                        className="form-label "
                                        htmlFor="collapsible-supplierType"
                                      >
                                        Fundraising Goal*
                                      </label>
                                      <div className="row ms-1 d-flex flex-nowrap">
                                        <span className="input-group-addon">
                                          $
                                        </span>
                                        <input
                                          title=""
                                          required
                                          type="number"
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control rounded-0"
                                          value={this.state.fundraisingGoal}
                                          onChange={this.handleFundraisingGoalChange.bind(
                                            this
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row d-flex align-items-center justify-content-between">
                  <div className="col-sm-12 mt-3 text-center">
                    <CreateButton btnName="Create" type="submit" />
                    {/* &nbsp;&nbsp;
                    <CancelIconButton onClick={(e) => this.editCancel()} /> */}
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
  editMessageTemplate() {
    if (this.state.render === false) {
      return <div />;
    } else {
      let questionitems = [];
      /* Create List of Expense Item */
      let itemLoc = 1;
      this.state.questionItems.forEach((element, index) => {
        if ("Delete" !== element.operation) {
          element.step = itemLoc++;
          let itemkey = index + "-" + this.state.refreshKey;
          questionitems.push(
            <MessageQuestion
              ref={this.itemReferenceList[index]}
              key={itemkey}
              data={element}
              srno={index}
              action="edit"
              iteamIndex={index}
              questionItems={this.state.questionItems}
              onAdd={this.addQuestionItem.bind(this)}
              onDelete={this.QuestionItemDeleted.bind(this)}
              // onChange={this.expenseItemChanged.bind(this)}
              onSuccess={this.smsQuestionTypeChange.bind(this)}
            />
          );
        }
      });
      return (
        <>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            maxWidth="xxl"
            className="TemplateDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Message Template</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div
                className="row d-flex"
                style={{
                  color: "#000",
                  fontSize: "small",
                }}
              >
                <ValidatorForm
                  className="text-start"
                  ref="form"
                  onSubmit={this.updateMsgTemplateToBackend.bind(this)}
                >
                  <div className="row" style={{ marginTop: "1em" }}>
                    <div className="col-md-12">
                      <div className="card" id="organizationFormCard">
                        <div className="card-body">
                          <div
                            className="row"
                            style={{
                              borderBottom: "1px solid rgb(228, 222, 222)",
                            }}
                          >
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-firstname"
                                  >
                                    Message Title*
                                  </label>
                                  <input
                                    title=""
                                    required
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    value={this.state.messageName}
                                    onChange={this.handleMessageNameChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                              <div className="row mt-1">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="MuiAutocomplete-label form-label"
                                    htmlFor="collapsible-appUserRole"
                                  >
                                    Message Type*
                                  </label>
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disabled
                                    disableClearable
                                    autoComplete="off"
                                    options={this.smsMessageTypeList}
                                    value={this.state.messageType}
                                    getOptionLabel={(option) => option.type}
                                    defaultValue={this.state.messageType}
                                    onChange={(event, value) => {
                                      this.handleMessageTypeChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row mt-1 mb-4">
                                <div className="col-md-6" id="assetFormLabel">
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-lastname"
                                  >
                                    Keyword
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsKeyword"
                                    name="multiStepsKeyword"
                                    className="form-control"
                                    value={this.state.keyword}
                                    onChange={this.handleKeywordChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mt-2 mb-4">
                            {!Utils.equalsIgnoreCase(
                              this.state.messageType?.type,
                              MESSAGE_TYPES.interactive
                            ) &&
                              !Utils.equalsIgnoreCase(
                                this.state.messageType?.type,
                                MESSAGE_TYPES.fundraising
                              ) && (
                                <div
                                  className="col-md-6 mt-1"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-appUserRole"
                                  >
                                    Message*
                                  </label>
                                  <textarea
                                    title=""
                                    required
                                    value={this.state.message}
                                    onChange={this.handleMessageChange.bind(
                                      this
                                    )}
                                    className="form-control"
                                    id="exampleFormControlTextarea1"
                                    rows="3"
                                  />
                                </div>
                              )}
                          </div>
                          {Utils.equalsIgnoreCase(
                            this.state.messageType?.type,
                            MESSAGE_TYPES.interactive
                          ) && (
                              <>
                                <div className="row" style={{ marginTop: "1em" }}>
                                  <div className="col-md-12">
                                    {/* <div className="row mb-3"> */}
                                    {questionitems.length === 0 && (
                                      <div className="row">
                                        <div
                                          className="col-md-8"
                                          style={{
                                            background: "#ececec",
                                            color: "#000",
                                            fontWeight: "bold",
                                            border: "0.5px solid #ece6e6",
                                            padding: "0.5em",
                                          }}
                                        >
                                          {/* Message Type */}
                                        </div>
                                        <div
                                          className="col-md-4"
                                          style={{
                                            borderRight: "1px solid #eceaea",
                                            background: "#ececec",
                                            color: "#000",
                                            fontWeight: "bold",
                                            padding: "0.5em",
                                            textAlign: "right",
                                          }}
                                        >
                                          <Button
                                            type="button"
                                            // id="ptsHollowButton"
                                            className="btn btn-default "
                                            style={{
                                              textTransform: "capitalize",
                                              padding: "5px 10px",
                                              background: "#37517e",
                                              color: "#fff",
                                              fontWeight: "bold",
                                            }}
                                            startIcon={<AddIcon />}
                                            onClick={this.addQuestionItem.bind(
                                              this
                                            )}
                                          >
                                            Insert Message
                                          </Button>
                                        </div>
                                      </div>
                                    )}
                                    <div className="row">
                                      <div className="col-md-12">
                                        {questionitems}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: "1em" }}>
                                  <div className="col-md-12">
                                    <div className="row mb-3">
                                      <div className="col-md-6">
                                        <label
                                          htmlFor="exampleFormControlTextarea1"
                                          className="form-label"
                                        >
                                          Closing/Thank You Message*
                                        </label>
                                        <textarea
                                          title=""
                                          required
                                          value={this.state.closingTextMessage}
                                          onChange={this.handleClosingTextMessageChange.bind(
                                            this
                                          )}
                                          className="form-control"
                                          id="exampleFormControlTextarea1"
                                          rows="3"
                                        />
                                      </div>
                                      <div className="col-md-3 mt-4">
                                        <ul style={{ listStyle: "none" }}>
                                          {this.smsVariablesList.map(
                                            (data, index) => {
                                              return (
                                                <>
                                                  <li className="d-flex mt-1">
                                                    <Tooltip
                                                      title={data.value}
                                                      aria-label="add"
                                                      classes={{
                                                        popper: "custom-tooltip",
                                                      }}
                                                    >
                                                      <IconButton>
                                                        <CopyToClipboard
                                                          text={data.value}
                                                          onClick={this.onCopy}
                                                        >
                                                          <FileCopyIcon
                                                            style={{
                                                              color: "gray",
                                                              fontSize: "20px",
                                                            }}
                                                            onClick={this.handleClosingTextMessageInsert.bind(
                                                              this,
                                                              data
                                                            )}
                                                          />
                                                        </CopyToClipboard>
                                                      </IconButton>
                                                    </Tooltip>
                                                    &nbsp;
                                                    <div
                                                      className="mt-2"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onDragEnd={this.handleSmsVariableOnDrag.bind(
                                                        this
                                                      )}
                                                      key={index}
                                                      draggable
                                                    >
                                                      {data.value}
                                                    </div>
                                                  </li>
                                                </>
                                              );
                                            }
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          {Utils.equalsIgnoreCase(
                            this.state.messageType?.type,
                            MESSAGE_TYPES.fundraising
                          ) && (
                              <>
                                <div className="row" style={{ marginTop: "1em" }}>
                                  <div className="col-md-12">
                                    <div className="row">
                                      <h6>
                                        <b>Choose a Donor Experience</b>
                                      </h6>
                                    </div>
                                    {this.smsFundraisingOptionList.map(
                                      (row, index) => {
                                        return (
                                          <>
                                            <div className="row p-1">
                                              <label
                                                className="col-md-3 col-form-label fw-bold"
                                                htmlFor="basic-default-supplierType"
                                                id="assetFormLabel"
                                              >
                                                <span className="me-2 custom-radio">
                                                  <input
                                                    type="radio"
                                                    value={row.id}
                                                    onChange={(e) =>
                                                      this.handleChange(e, row)
                                                    }
                                                    checked={row.isChecked}
                                                  />
                                                </span>
                                                <span className="me-4">
                                                  {row.name}
                                                </span>
                                                {"  "}
                                                <span className="ms-4 fw-normal">
                                                  {row.name ===
                                                    "With Introduction"
                                                    ? "(more descriptive)"
                                                    : "(fewer steps)"}
                                                </span>
                                              </label>
                                              <div className="col-md-9 mt-2">
                                                <span>{row.description}</span>
                                              </div>
                                            </div>
                                          </>
                                        );
                                      }
                                    )}
                                    {this.state.isIntroMessage && (
                                      <div className="row p-1">
                                        <div className="col-md-3 mt-2"></div>
                                        <div className="col-md-6 mt-2">
                                          <span>
                                            Enter an Introduction Message that
                                            includes your organization's name and
                                            what this appeal is about. It must
                                            also elicit a "Yes" or "No" reply from
                                            recipient.
                                          </span>
                                          <textarea
                                            title=""
                                            required
                                            value={this.state.introMessage}
                                            onChange={this.handleIntroMessageChange.bind(
                                              this
                                            )}
                                            className="form-control"
                                            id="exampleFormControlTextarea1"
                                            rows="3"
                                          />
                                          <span
                                            className="ms-2"
                                            style={{
                                              fontSize: "12px",
                                              color: "black",
                                            }}
                                          >
                                            Whenever possible, please include
                                            opt-out language in your text message
                                            to show the carriers that you are
                                            following guidelines.
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: "1em" }}>
                                  <div className="col-md-12">
                                    <div className="row mb-3">
                                      <div className="col-md-6">
                                        <label
                                          htmlFor="exampleFormControlTextarea1"
                                          className="form-label"
                                        >
                                          Your "How much?" Question*
                                        </label>
                                        <textarea
                                          title=""
                                          required
                                          value={this.state.amountQuestion}
                                          onChange={this.handleAmountQustionChange.bind(
                                            this
                                          )}
                                          className="form-control"
                                          id="exampleFormControlTextarea1"
                                          rows="3"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: "1em" }}>
                                  <div className="col-md-12">
                                    <div className="row mb-3">
                                      <label
                                        htmlFor="exampleFormControlTextarea1"
                                        className="form-label"
                                      >
                                        Your Suggested Donation Amounts*
                                        <InfoTooltip
                                          data="Up to 4 allowed"
                                          style={{
                                            float: "right",
                                          }}
                                        />
                                      </label>
                                    </div>
                                    <div className="row mb-3 ">
                                      <div className="col-md-3 d-flex">
                                        <span className="input-group-addon">
                                          $
                                        </span>
                                        <input
                                          type="number"
                                          autoComplete="off"
                                          id="multiStepsFirstName"
                                          name="multiStepsFirstName"
                                          className="form-control rounded-0"
                                          value={this.state.donationAmount}
                                          onChange={this.handleDonationAmountChange.bind(
                                            this
                                          )}
                                        />
                                        <span>
                                          <button
                                            type="button"
                                            onClick={this.addDonationAmount.bind(
                                              this
                                            )}
                                            className="btn addDonationBtn btn-primary"
                                          >
                                            Add
                                          </button>
                                        </span>
                                      </div>
                                    </div>
                                    <div className="row mt-4">
                                      <div className="col-md-4">
                                        <ul
                                          style={{
                                            listStyle: "none",
                                            display: "flex",
                                          }}
                                        >
                                          {this.state.donationAmountList?.map(
                                            (amountValue, index) => {
                                              return (
                                                <>
                                                  {
                                                    <div className="donation d-flex">
                                                      <li>${amountValue}</li>
                                                      <span className="ms-4">
                                                        <i
                                                          className="fa fa-times"
                                                          aria-hidden="true"
                                                          onClick={this.deleteDonationAmount.bind(
                                                            this,
                                                            index
                                                          )}
                                                        ></i>
                                                      </span>
                                                    </div>
                                                  }
                                                </>
                                              );
                                            }
                                          )}
                                        </ul>
                                        <span className="asterisk">
                                          {this.state.donationAmountError
                                            ? "No suggested donation amounts are set."
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                      <div
                                        className="col-md-4 mt-1"
                                        id="assetFormLabel"
                                      >
                                        <label
                                          className="form-label "
                                          htmlFor="collapsible-supplierType"
                                        >
                                          Fundraising Goal*
                                        </label>
                                        <div className="row ms-1 d-flex flex-nowrap">
                                          <span className="input-group-addon">
                                            $
                                          </span>
                                          <input
                                            title=""
                                            required
                                            type="number"
                                            autoComplete="off"
                                            id="multiStepsFirstName"
                                            name="multiStepsFirstName"
                                            className="form-control rounded-0"
                                            value={this.state.fundraisingGoal}
                                            onChange={this.handleFundraisingGoalChange.bind(
                                              this
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row d-flex align-items-center justify-content-between">
                    <div className="col-sm-12 mt-3 text-center">
                      <SaveButton id="saveButton" type="submit">
                        {" "}
                        Save{" "}
                      </SaveButton>
                      {/* &nbsp;&nbsp;
                    <CancelIconButton onClick={(e) => this.editCancel()} /> */}
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            </DialogContent>
          </Dialog>
        </>
      );
    }
  }
}
export default CustomerMessageTemplate;
